import React from 'react';
import ResetIcon from '@mui/icons-material/RestartAlt';

import { TooltipIconButton } from '@paragon/client-tools';

import { TrussEnvelopeSnappingSettings } from '../../../../../library/layout-geometry/truss-envelopes/types';
import { InteractiveEditSnappingSettings } from '../../../../../library/layout-snapping/interactive-snapping/settings';
import { PointSnappingSettings } from '../../../../../library/layout-snapping/point-snapping/settings';
import {
  areInteractiveEditSnappingSettingsModified,
  arePointSnappingSettingsModified,
  areTrussEnvelopeSnappingSettingsModified,
  layoutSlice,
  PointSnappingContext,
} from '../../../../../store/slices/layoutSlice';
import { useAppDispatch } from '../../../../hooks';

type Props =
  | {
      context: PointSnappingContext;
      settings: PointSnappingSettings;

      trussEnvelopeSnappingSettings?: TrussEnvelopeSnappingSettings;
    }
  | {
      context: 'interactiveEdit';
      settings: InteractiveEditSnappingSettings;
    };

export function SnappingSettingsResetButton(props: Props) {
  const dispatch = useAppDispatch();

  const settingsModified =
    props.context === 'interactiveEdit'
      ? areInteractiveEditSnappingSettingsModified(props.settings)
      : arePointSnappingSettingsModified(props.context, props.settings);

  const envelopeSettingsModified =
    props.context !== 'interactiveEdit' &&
    props.trussEnvelopeSnappingSettings &&
    areTrussEnvelopeSnappingSettingsModified(props.trussEnvelopeSnappingSettings);

  if (!settingsModified && !envelopeSettingsModified) return null;

  return (
    <TooltipIconButton
      title="Reset snapping settings to their default values"
      onClick={() => {
        if (settingsModified) {
          if (props.context === 'interactiveEdit') {
            dispatch(layoutSlice.actions.interactiveEditSnappingSettingsReset());
          } else {
            dispatch(layoutSlice.actions.pointSnappingSettingsReset(props.context));
          }
        }

        if (envelopeSettingsModified) dispatch(layoutSlice.actions.trussEnvelopeSnappingSettingsReset());
      }}
    >
      <ResetIcon />
    </TooltipIconButton>
  );
}
